import { BUDGET_TYPE_INTERNAL } from '../../components/Common/Budgets/BudgetCont'
import AccountsCont from '../../components/Corporate/Accounts/AccountsCont'
import Analytics from '../../components/Corporate/Analytics/Analytics'
import ReportCont from '../../components/Corporate/Analytics/Reports/ReportCont'
import AddBudgetCont from '../../components/Corporate/Budgets/AddBudget/AddBudgetCont'
import BudgetsCont from '../../components/Corporate/Budgets/BudgetsCont'
import CashflowCont from '../../components/Corporate/Cashflow/CashflowCont'
import Centers from '../../components/Corporate/Centers/Centers'
import Government from '../../components/Corporate/Government/Government'
import GovernmentList from '../../components/Corporate/GovernmentList'
import Report from '../../components/Corporate/Report/Report'
import SubsidiaryCont from '../../components/Corporate/Subsidiary/SubsidiaryCont'
import SubsidiaryList from '../../components/Corporate/SubsidiaryList'
import NoMatchComponent from '../../components/NoMatch'
import React from 'react'
import { Route, Switch } from 'react-router-dom'

export default function CorporateRouter(props) {
  const url = props.match.url
  return (
    <Switch>
      <Route path={`${url}/cashflow`} component={CashflowCont} />
      <Route path={`${url}/governments/list`} component={GovernmentList} />
      <Route path={`${url}/report`} component={Report} />

      <Route path={`${url}/analytics/:key`} component={ReportCont} />
      <Route path={`${url}/analytics`} component={Analytics} />

      <Route path={`${url}/governments/new`} component={() => <h1>New Government</h1>} />
      <Route path={`${url}/governments/:key/`} component={Government} />
      <Route path={`${url}/subsidiaries/list`} component={SubsidiaryList} />
      <Route path={`${url}/accounts/`} component={AccountsCont} />
      <Route path={`${url}/budgets/new`} component={AddBudgetCont} />
      <Route path={`${url}/budgets/:key`} component={AddBudgetCont} />
      <Route
        path={`${url}/budgets/`}
        component={() => <BudgetsCont option={BUDGET_TYPE_INTERNAL} />}
      />
      <Route path={`${url}/centers/`} component={Centers} />
      <Route path={`${url}/subsidiaries/new`} component={() => <h1>New Subsidiary</h1>} />
      <Route path={`${url}/subsidiaries/:key/`} component={SubsidiaryCont} />
      <Route component={NoMatchComponent} />
    </Switch>
  )
}
